export default "__VITE_ASSET__SbEA7TLN__"